import React, { useEffect, useState } from 'react';
const LOADING_MESSAGES = ["Thinking through Naval's frameworks…", 'Applying principles of leverage…', 'Considering specific knowledge…', 'Examining long-term consequences…'];
interface LoadingStepProps {
  onTimeout?: () => void;
  timeoutMs?: number;
}
export function LoadingStep({
  onTimeout,
  timeoutMs = 8000
}: LoadingStepProps) {
  const [messageIndex, setMessageIndex] = useState(0);
  const [showTimeout, setShowTimeout] = useState(false);
  useEffect(() => {
    const messageInterval = setInterval(() => {
      setMessageIndex(prev => (prev + 1) % LOADING_MESSAGES.length);
    }, 2000);
    return () => clearInterval(messageInterval);
  }, []);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowTimeout(true);
      onTimeout?.();
    }, timeoutMs);
    return () => clearTimeout(timeout);
  }, [timeoutMs, onTimeout]);
  return <div className="w-full max-w-2xl mx-auto text-center" data-id="element-32">
      <div className="flex flex-col items-center justify-center py-16" data-id="element-33">
        {/* Animated dots */}
        <div className="flex items-center gap-2 mb-8" data-id="element-34">
          <div className="w-3 h-3 rounded-full bg-foreground animate-pulse" style={{
          animationDelay: '0ms'
        }} data-id="element-35" />
          <div className="w-3 h-3 rounded-full bg-foreground animate-pulse" style={{
          animationDelay: '150ms'
        }} data-id="element-36" />
          <div className="w-3 h-3 rounded-full bg-foreground animate-pulse" style={{
          animationDelay: '300ms'
        }} data-id="element-37" />
        </div>

        <p className="text-lg text-foreground font-medium transition-opacity duration-300" data-id="element-38">
          {LOADING_MESSAGES[messageIndex]}
        </p>

        {showTimeout && <p className="text-sm text-muted-foreground mt-4 animate-in fade-in duration-300" data-id="element-39">
            This is taking longer than expected. Please wait…
          </p>}
      </div>
    </div>;
}